import { render, staticRenderFns } from "./ConcatenateView.vue?vue&type=template&id=2b8e77ce&scoped=true"
import script from "./ConcatenateView.vue?vue&type=script&lang=js"
export * from "./ConcatenateView.vue?vue&type=script&lang=js"
import style1 from "./ConcatenateView.vue?vue&type=style&index=1&id=2b8e77ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8e77ce",
  null
  
)

export default component.exports